import api from './api';

export const getSlidersByPageCode = async (pageCode) => {
  try {
    console.log('Requesting sliders for page:', pageCode);
    const response = await api.post('/GetSlidersByPageCode', {
      pageCode: pageCode || 'MainPage'
    });
    console.log('Sliders response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error getting sliders:', error);
    return { isSuccess: false, resultMessage: error.message };
  }
};

export const addSlider = async (data) => {
  const token = localStorage.getItem('token');
  try {
    if (!token) {
      throw new Error('No authentication token found');
    }

    let pictureBase64 = '';

    // Form'dan gelen pictureBase64'i kontrol et
    if (data.pictureBase64) {
      console.log('Form\'dan gelen base64 verisi kullanılıyor');
      // Form'dan gelen base64 verisi data:image/jpeg;base64, ile başlıyor
      // API'ye tüm base64 verisini göndermemiz gerekiyor (prefix dahil)
      pictureBase64 = data.pictureBase64;
      console.log('Base64 verisi kullanılıyor, örnek:', pictureBase64.substring(0, 50) + '...');
    } else if (data.picture) {
      console.log('Resim dönüştürülüyor:', {
        name: data.picture.name,
        type: data.picture.type,
        size: `${(data.picture.size / 1024).toFixed(2)} KB`
      });

      // Convert picture to base64
      pictureBase64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(data.picture);
        reader.onload = () => {
          const base64 = reader.result;
          console.log('Resim base64 dönüşümü tamamlandı:', {
            originalSize: `${(data.picture.size / 1024).toFixed(2)} KB`,
            base64Size: `${(base64.length * 0.75 / 1024).toFixed(2)} KB`,
            base64Preview: `${base64.substring(0, 100)}...`
          });
          // Tüm base64 verisini gönder (prefix dahil)
          resolve(base64);
        };
        reader.onerror = error => reject(error);
      });
    } else {
      console.error('Resim verisi bulunamadı!');
    }

    const fileUrl = '';
    const pictureUrl = data.pictureUrl || data.picture?.name || '';
    const intervalSecond = data.intervalSecond || 5000;
    const pageCode = data.pageCode || 'MainPage';
    const url = data.url || '';
    const indexOrder = data.indexOrder || 0;

    // Prepare request body according to the required format
    const requestBody = {
      fileUrl: fileUrl,
      intervalSecond: intervalSecond,
      pageCode: pageCode,
      pictureUrl: pictureUrl,
      pictureBase64: pictureBase64,
      url: url,
      indexOrder: indexOrder
    };

    console.log('Gönderilecek slider verisi:', {
      ...requestBody,
      pictureBase64: pictureBase64 ? `${pictureBase64.substring(0, 50)}...` : null
    });

    const response = await api.post('/AddSliders', requestBody, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Add slider response:', response.data);
    
    // API true veya ServiceResult dönebilir, ikisini de kontrol edelim
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true, resultMessage: 'Slider başarıyla eklendi' };
    }
    return response.data;
  } catch (error) {
    console.error('Error adding slider:', error);
    return { isSuccess: false, resultMessage: error.message };
  }
};

export const updateSlider = async (data) => {
  const token = localStorage.getItem('token');
  try {
    if (!token) {
      throw new Error('No authentication token found');
    }

    const requestBody = {
      guid: data.guid,
      fileUrl: data.fileUrl || '',
      pictureBase64: data.pictureBase64 || undefined,
      intervalSecond: data.intervalSecond || 5000,
      pageCode: data.pageCode || 'MainPage',
      url: data.url || '',
      indexOrder: data.indexOrder || 0
    };

    console.log('Slider güncelleniyor:', requestBody.guid);

    const response = await api.post('/UpdateSliders', requestBody, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    
    console.log('Update slider response:', response.data);
    
    // API true veya ServiceResult dönebilir, ikisini de kontrol edelim
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true, resultMessage: 'Slider başarıyla güncellendi' };
    }
    return response.data;
  } catch (error) {
    console.error('Error updating slider:', error);
    return { isSuccess: false, resultMessage: error.message };
  }
};

export const deleteSlider = async (guid) => {
  const token = localStorage.getItem('token');
  try {
    console.log('Deleting slider with guid:', guid);
    
    // Guid'in string olduğundan emin ol
    const guidValue = guid?.toString() || '';
    
    if (!guidValue) {
      console.error('Geçersiz guid: boş veya tanımsız');
      return { isSuccess: false, resultMessage: 'Geçersiz slider ID' };
    }
    
    // API'nin beklediği formatta request body oluştur
    const requestBody = {
      guid: guidValue
    };
    
    console.log('Slider silme için gönderilen veri:', requestBody);
    
    const response = await api.post('/DeleteSliders', requestBody, {
      headers: {
        Authorization: `Bearer ${token}`
      }
      
    });
    
    console.log('Slider silme yanıtı:', response.data);
    
    // API true veya "true" dönebilir, ikisini de kontrol edelim
    if (response.data === true || response.data === 'true') {
      return { isSuccess: true };
    }
    return response.data;
  } catch (error) {
    console.error('Error deleting slider:', error);
    if (error.response) {
      console.error('API Error:', {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers
      });
    }
    return { isSuccess: false, resultMessage: error.message };
  }
};
